/* Layout only: Essential Countdown Timer owns all countdown behavior. */
(function () {
  'use strict';
  if (window.bmdMobileCountdownLayout) return;
  window.bmdMobileCountdownLayout = true;

  var selector = '.countdown_annoucement_bar_wrapper_cmontavgt003bkym6a4wzk3lw.top_page';
  var property = '--bmd-mobile-countdown-height';
  var mobile = window.matchMedia('(max-width: 798px)');
  var root = document.documentElement;
  var timer = null;
  var frame = 0;
  var resizeObserver = window.ResizeObserver ? new ResizeObserver(schedule) : null;

  function update() {
    frame = 0;
    var next = document.querySelector(selector);
    if (next !== timer) {
      if (timer && resizeObserver) resizeObserver.unobserve(timer);
      timer = next;
      if (timer && resizeObserver) resizeObserver.observe(timer);
    }
    if (!mobile.matches || !timer || !timer.getClientRects().length) {
      root.style.removeProperty(property);
      return;
    }
    var height = Math.ceil(timer.getBoundingClientRect().height);
    root.style.setProperty(property, height + 'px');
  }

  function schedule() {
    if (!frame) frame = window.requestAnimationFrame(update);
  }

  function start() {
    // The app prepends its bar asynchronously. Direct children only: timer ticks
    // and reviews below the body do not trigger a whole-page rescan.
    new MutationObserver(schedule).observe(document.body, { childList: true });
    schedule();
  }

  window.addEventListener('resize', schedule, { passive: true });
  if (mobile.addEventListener) mobile.addEventListener('change', schedule);
  else mobile.addListener(schedule);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
